(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const english = document.documentElement.lang.startsWith('en');
  function attach(root) {
    if (root.dataset.maisonAttached) return;
    root.dataset.maisonAttached = '1';
    const track = root.querySelector('[data-maison-track]');
    const button = root.querySelector('[data-maison-pause]');
    if (!track || track.children.length < 2) return;
    let paused = false, hovered = false, focused = false, visible = false, timer = 0;
    const allowed = () => !paused && !hovered && !focused && visible && !document.hidden && !reduced.matches && document.documentElement.dataset.ayReduced !== 'true' && root.isConnected;
    function schedule() {
      clearTimeout(timer);
      timer = 0;
      if (!allowed()) return;
      timer = setTimeout(() => {
        if (!allowed()) return;
        const max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: track.scrollLeft >= max - 4 ? 0 : track.scrollLeft + track.firstElementChild.getBoundingClientRect().width + 16, behavior: 'smooth' });
        schedule();
      }, 5500);
    }
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    observer.observe(root);
    root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); schedule(); });
    function updateButton() {
      if (!button) return;
      button.innerHTML = paused ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m8 5 11 7-11 7z" fill="currentColor"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14M16 5v14" fill="none" stroke="currentColor" stroke-width="3"/></svg>';
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? (english ? 'Resume reviews' : 'Reprendre le défilement des avis') : (english ? 'Pause reviews' : 'Mettre les avis en pause'));
    }
    button?.addEventListener('click', () => { paused = !paused; updateButton(); schedule(); });
    root.addEventListener('touchstart', () => { clearTimeout(timer); timer = 0; }, { passive: true });
    root.addEventListener('touchend', schedule, { passive: true });
    root.addEventListener('touchcancel', schedule, { passive: true });
    document.addEventListener('ay:comfortchange', schedule);
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', schedule);
    updateButton();
  }
  function init() {
    document.querySelectorAll('[data-maison-carousel]').forEach(attach);
    document.querySelectorAll('.ay-testimonials__platform').forEach(platform => {
      const rail = platform.querySelector('.ay-testimonials__rail');
      if (!rail || rail.children.length < 2) return;
      platform.dataset.maisonCarousel = '';
      rail.dataset.maisonTrack = '';
      if (!platform.querySelector('.maison-carousel-controls')) {
        const controls = document.createElement('div');
        controls.className = 'maison-carousel-controls';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'maison-review-pause';
        button.dataset.maisonPause = '';
        controls.append(button);
        rail.before(controls);
      }
      attach(platform);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  'use strict';
  const help = document.querySelector('[data-maison-help]');
  if (!help) return;
  let seen = false;
  try { seen = sessionStorage.getItem('ay-help-seen') === '1'; } catch (_) {}
  if (seen) return;
  let remaining = 45000, started = 0, timer = 0;
  function remember() { try { sessionStorage.setItem('ay-help-seen', '1'); } catch (_) {} }
  function pause() { if (timer) { clearTimeout(timer); timer = 0; remaining -= Date.now() - started; } }
  function schedule() {
    pause();
    if (document.hidden || seen) return;
    started = Date.now();
    timer = setTimeout(() => {
      timer = 0;
      // Avoid covering a focused search field, open chat, or other active input.
      const active = document.activeElement;
      if (active && /INPUT|TEXTAREA|SELECT|IFRAME/.test(active.tagName)) { remaining = 15000; schedule(); return; }
      seen = true; remember(); help.hidden = false;
    }, Math.max(0, remaining));
  }
  function close() { help.hidden = true; seen = true; pause(); remember(); }
  help.querySelector('[data-maison-help-close]').addEventListener('click', close);
  help.addEventListener('keydown', event => {
    if (event.key === 'Escape') { close(); document.getElementById('MainContent')?.focus(); }
  });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pagehide', pause, { once: true });
  schedule();
})();

